<template src="./LaboratorySearch.html" />

<script>
import { useStore } from "@/store/store.js"
import Modal from "@/components/modal-maps/modal.component.vue"
import mixins from "@/Mixins.js"

export default {
  name: "medicine",
  mixins: [mixins],
  components: {
    Modal
  },
  data: () => ({
    patient_id: "",
    medicine: true,
    phamacy_p: false,
    cepSearch: "",
    selected: [],
    medicamentos_pharmacy: [],
    addres: [],
    cepPharmacy: "",
    addressPharmacy: "",
    latPharmacy: "",
    lngPharmacy: "",
    errorStr: "",
    gettingLocation: false,
    order: "ASC",
    order_distance: 250,
    show_input_cep: false,
    transitionName: "fade",
    farmacias: [],
    farmaciasTodas: [],
    configs: {
      orderBy: "preco",
      order: "asc",
      filter: ""
    },
    bodyParameters: {},
    popupLaboratoryAdd: false,
    currentx: 1,
    numPages: 0,
    pagination: false,
    windowWidth: 0,
    cardsPerPage: 9,
    labsGroup: {},
    popupLaboratoryData: {
      id: undefined,
      labId: undefined,
      name: "test",
      phone: undefined,
      address: {
        zipcode: undefined,
        city: undefined,
        complement: undefined,
        neighborhood: undefined,
        number: undefined,
        state: undefined,
        street: undefined
      }
    },
    pageLoaded: false,
    address: {
      zipcode: "",
      city: "",
      complement: "",
      neighborhood: "",
      number: "",
      state: "",
      street: ""
    },
    invalidFields: {
      zipcode: false
    },
    filterByName: "",
    showFilterByName: false,
    farmaciasTodasFiltradas: [],
    mapLatitude: 0,
    mapLongitude: 0,
  }),
  
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },

  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  
  mounted () {
    const vm = this;
    vm.patient_id = vm.$session.get("id");
    vm.pageLoaded = true;
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    cepSearch (newVal) {
      const vm = this;
      vm.invalidFields.zipcode = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.zipcode;
    },
    currentx () {
      const vm = this;
      vm.changePagination();
    },
  },

  methods: {
    addNewLaboratoryPopup() {
      const vm = this;
      vm.popupLaboratoryAdd = true;
      vm.popupLaboratoryData = {
        id: undefined,
        name: undefined
      };
    },

    addNewLaboratory() {},

    editLaboratoryPopup(f) {
      const vm = this;
      console.log(f)
      vm.popupLaboratoryAdd = true;
      vm.popupLaboratoryData = f;
    },
    editLaboratory() {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "orizon/putAddress/",
          vm.popupLaboratoryData,
          {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.popupLaboratoryAdd = false;
            vm.getLabs();
          }
        });
    },

    changePagination() {
      const vm = this;
      if (vm.currentx == 1) {
        vm.farmacias = vm.farmaciasTodasFiltradas.slice(0, vm.cardsPerPage);
      } else {
        vm.farmacias = vm.farmaciasTodasFiltradas.slice(
          vm.cardsPerPage * vm.currentx,
          vm.cardsPerPage * vm.currentx + vm.cardsPerPage
        );
      }
    },

    getLabs() {
      const vm = this;
      vm.axios
        .post(
          vm.$store.state.filooServer + "orizon/labsdist",
          {
            lat: vm.latPharmacy,
            lng: vm.lngPharmacy
          },
          {
            headers: {
              Authorization: vm.$session.get("bearer")
            }
          }
        )
        .then(function(response) {
          vm.farmaciasTodas = response.data;
          vm.farmaciasTodasFiltradas = vm.farmaciasTodas;
          vm.farmacias = vm.farmaciasTodasFiltradas.slice(0, vm.cardsPerPage);
          vm.calculatePages();
          for (var x = 0; x < vm.farmaciasTodasFiltradas.length; x++) {
            if (!vm.labsGroup[vm.farmaciasTodasFiltradas[x].labId]) {
              vm.labsGroup[vm.farmaciasTodasFiltradas[x].labId] = [];
            }
            vm.labsGroup[vm.farmaciasTodasFiltradas[x].labId].push(
              vm.farmaciasTodasFiltradas[x].id
            );
          }
          vm.showFilterByName = !vm.testNullUndefinedEmpty(vm.farmaciasTodasFiltradas);
          vm.$vs.loading.close();
        })
        .catch(function() {
          vm.showFilterByName = false;
        })
        .finally(function() {
          vm.$vs.loading.close();
          vm.showFilterByName = true;
        });
    },
    async getAddressData() {
      const response = await this.getAddressByZipcode(this.address.zipcode)

      if (response && response.address) {
        this.address.state = response.address.state
        this.address.neighborhood = response.address.neighborhood
        this.address.city = response.address.city
        this.address.zipcode = response.address.zipcode
        this.address.street = response.address.street
      }
    },

    getPosition(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    googleMaps(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    async searchAddressLabs() {
      this.invalidFields.zipcode = !this.validateZipCode(this.cepSearch)

      if (!this.invalidFields.zipcode) {
        this.$vs.loading();
        const response = await this.getAddressByZipcode(this.cepSearch)

        if (response && response.address) {
          this.cepPharmacy = this.cepSearch

          const { street, neighborhood, city, state } = response.address

          this.addressPharmacy = `${street}, ${neighborhood} - ${city} / ${state}`
          this.latPharmacy = response.lat
          this.lngPharmacy = response.lng
        } else {
          this.addressPharmacy = ""
          this.invalidFields.zipcode = true
          this.addressPharmacy = ""
          this.farmaciasTodas = []
          this.farmaciasTodasFiltradas = []
          this.farmacias = []
        }
        
        this.$vs.loading.close()
        this.showFilterByName = !this.invalidFields.zipcode
      }
    },

    getGeolocationLabs() {
      const vm = this;
      vm.invalidFields.zipcode = false;
      if (!("geolocation" in navigator)) {
        vm.errorStr = "Geolocalização não está habilitada.";
        return;
      }
      vm.$vs.loading();
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      function success(pos) {
        var crd = pos.coords;

        vm.latPharmacy = crd.latitude;
        vm.lngPharmacy = crd.longitude;
        vm.cepSearch = "";
      }

      function error() {
        vm.addressPharmacy = "";
      }
      navigator.geolocation.getCurrentPosition(success, error, options);
      setTimeout(() => {
        vm.getLabs();
      }, 2000);
    },

    getZipLabs() {},

    replaceSpecialChars(str) {
      if (!str) return "";
      str = str.toLowerCase();
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
      };
      for (var letra in mapaAcentosHex) {
        var expressaoRegular = mapaAcentosHex[letra];
        str = str.replace(expressaoRegular, letra);
      }
      str = str.toUpperCase();
      return str;
    },

    maskMoney(value) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
      var newValue = parseFloat(value);
      var newValueFormat = formatter.format(newValue);
      return newValueFormat;
    },

    distanciaEmKms(dist) {
      var res = Math.floor(dist);
      res = dist / 1000;
      if (res > 1) {
        return Math.round((res + Number.EPSILON) * 100) / 100 + " KMs";
      } else {
        return Math.round((res + Number.EPSILON) * 100) / 100 + " m";
      }
    },
    callMap(latitude, longitude) {
      const vm = this;
      console.log(vm.getPosition(latitude, longitude))
      console.log(vm.googleMaps(latitude, longitude))
      vm.mapLatitude = latitude;
      vm.mapLongitude = longitude;
      vm.$bvModal.show("modal-lab-location");
    },

    filterLabByName() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.filterByName)) {
        vm.farmaciasTodasFiltradas = vm.farmaciasTodas;
      } else {
        vm.farmaciasTodasFiltradas = vm.farmaciasTodas.filter(f => f.name.toUpperCase().includes(vm.filterByName.toUpperCase()));
        vm.currentx = 1;
        vm.calculatePages();
        vm.changePagination();
      }

    },

    calculatePages() {
      const vm = this;
      vm.numPages = Math.ceil(
        (vm.farmaciasTodasFiltradas.length / vm.cardsPerPage) -1
      );
      vm.pagination = vm.numPages > 1;
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./LaboratorySearch.scss" />
